import { Notification } from '@vwfs-bronson/bronson-react';

import React from 'react';

export const Container = ({ title = '', children }: { title?: string; children: React.ReactNode }) => {
    return (
        <Notification status="info" title={title} visible showCloseButton={false}>
            {children}
        </Notification>
    );
};
